"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendAsEpics = exports.loadSendAsEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _sendAs = require("./send-as.types");

var _sendAs2 = require("./send-as.actions");

var loadSendAsEpic = function loadSendAsEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_sendAs.GIFT_CREATE_LOAD_SEND_AS_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.loadSendAs(action.payload).pipe((0, _operators.map)(function (response) {
      return (0, _sendAs2.loadSendAsSuccess)(response.users);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _sendAs2.loadSendAsFail
    })));
  }));
};

exports.loadSendAsEpic = loadSendAsEpic;
var sendAsEpics = [loadSendAsEpic];
exports.sendAsEpics = sendAsEpics;